export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_money-match-16/artifacts/e3n4noa9_Copilot_20260614_013633.png";
export const APP_NAME = "SyncBook";
